// Where the job centre is, for its close view (components/ui/JobCentreHud.jsx, components/three/world/JobCentreCam.jsx):
// buildings_25, between City Mags and the community workshop on the row facing east (Sam, 30 Oct: "instead of the tech
// store, can we make it the currently selected building in Blender"), with its own front over the shutters
// (jobCentre.glb). The stand spot is the sceneConfig poi `jobCentre`; the front is where jobCentre.glb puts the glass.
// ?jobsAt=x,z puts the stand somewhere else, for trying the close view by hand.

import { POINTS_OF_INTEREST } from './sceneConfig.js'

// the middle of the shop's front, from the blend (x 84.08, the opening's middle at y 52.085, its glass 0.1 to 2.9 m up)
export const FRONT_AT = [84.08, 0, -52.09]
// the close view stands this far back across the street, at eye height, looking at the window, and this far to the
// side, so the building sits left of the panel docked on the right
const BACK = 9
const EYE = 2.6
const AIM = 2.4
const SIDE = 2.2

export function jobCentreSpot() {
  if (typeof window !== 'undefined') {
    const q = new URLSearchParams(window.location.search).get('jobsAt')
    const m = q && q.split(',').map(Number)
    if (m && m.length >= 2 && m.every(Number.isFinite)) return { at: [m[0] - 2, 0, m[1]], stand: [m[0], 0, m[1]] }
  }
  const p = POINTS_OF_INTEREST.find((x) => x.name === 'jobCentre')
  if (!p) return null
  return { at: FRONT_AT, stand: p.position }
}

/** The close view: back across the street from the shop's front, level with its window, a little to the side. */
export function jobCentreShot(spot) {
  if (!spot) return null
  const [ax, ay, az] = spot.at
  const [sx, , sz] = spot.stand
  const dx = sx - ax
  const dz = sz - az
  const d = Math.hypot(dx, dz) || 1
  // (to the viewer's right, looking back at the front: the panel's side)
  const rx = dz / d
  const rz = -dx / d
  return {
    eye: [ax + (dx / d) * BACK + rx * SIDE, (ay || 0) + EYE, az + (dz / d) * BACK + rz * SIDE],
    target: [ax + rx * SIDE, (ay || 0) + AIM, az + rz * SIDE],
  }
}
